import React from 'react'
import { Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface LoadingProps {
  withborder?: boolean
  iconless?: boolean
  messagetext?: string
  inline?: boolean
}

const Loading = ({
  withborder,
  iconless,
  messagetext,
  inline,
}: LoadingProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <Stack
      sx={{
        flexDirection: inline ? 'row' : 'column',
        alignItems: 'center',
        gap: '8px',
        fontSize: '12px',
        fontWeight: 500,
        color: theme.palette.grey['800'],
        border: withborder ? '1px solid #e2ecf3' : 'none',
        padding: withborder ? '16px 24px;' : 'none',
      }}
    >
      {!iconless && (
        <Stack
          sx={{
            fontSize: '16px',
            color: theme.palette.primary.main,
          }}
        >
          <i className={'fa-light fa-spin fa-spinner-third'} />
        </Stack>
      )}
      {messagetext || t('ui_elements.loading_msg')}
    </Stack>
  )
}

export default Loading
